var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrawlerNavTechnical = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Calque_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1000 1000",
  style: {
    enableBackground: "new 0 0 1000 1000"
  },
  xmlSpace: "preserve"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M617.5,152.6l-32.3-8.8c-4.2-1.4-8.2-0.9-12.2,1.3c-4,2.3-6.7,5.6-8.1,10.1L371,826.6c-1.4,4.5-1,8.8,1.3,12.7 c2.3,4,5.6,6.7,10.1,8.1l32.2,8.8c4.2,1.4,8.2,1,12.2-1.3c4-2.3,6.7-5.6,8.1-10.1l194-671.4c1.4-4.5,1-8.8-1.3-12.7 C625.4,156.6,622.1,154,617.5,152.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.8,283.6c0-4.5-1.7-8.5-5.2-12l-26-26c-3.5-3.5-7.5-5.2-12-5.2c-4.5,0-8.5,1.7-12,5.2L29.3,488 c-3.5,3.5-5.2,7.5-5.2,12c0,4.5,1.7,8.5,5.2,12l242.4,242.4c3.5,3.5,7.4,5.2,12,5.2c4.5,0,8.5-1.7,12-5.2l26-26 c3.5-3.5,5.2-7.5,5.2-12c0-4.5-1.7-8.5-5.2-12L117.2,500l204.4-204.4C325.1,292.1,326.8,288.2,326.8,283.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M970.7,488L728.3,245.7c-3.5-3.5-7.5-5.2-12-5.2c-4.5,0-8.5,1.7-12,5.2l-26,26c-3.5,3.5-5.2,7.5-5.2,12 c0,4.5,1.7,8.5,5.2,12L882.8,500L678.4,704.4c-3.5,3.5-5.2,7.5-5.2,12c0,4.5,1.7,8.5,5.2,12l26,26c3.5,3.5,7.5,5.2,12,5.2 c4.5,0,8.5-1.7,12-5.2L970.7,512c3.5-3.5,5.2-7.5,5.2-12C975.9,495.5,974.1,491.5,970.7,488z"
})))));
export default SvgCrawlerNavTechnical;